module.exports = __webpack_public_path__ + "static/img/icon-success.ab6a6a2a.png";